import { isEmpty, filter } from 'lodash';

const isTruthyFlag = (value) => (
  value === true || value === 'true' || value === 1
);

export const validateAvailable = (item) => (
  !item.track_quantity || item.selling_without_stock || Number(item.quantity) > 0
);

export const tracksLimitedStock = (item = {}) => (
  isTruthyFlag(item.track_quantity) && !isTruthyFlag(item.selling_without_stock)
);

export const getMaxOrderableQuantity = (item = {}) => {
  if (!tracksLimitedStock(item)) return null;

  return Math.max(0, Number(item.quantity) || 0);
};

export const clampOrderableQuantity = (item, quantity) => {
  const maxQuantity = getMaxOrderableQuantity(item);
  const parsedQuantity = Number(quantity) || 0;

  if (maxQuantity === null) return parsedQuantity;

  return Math.min(parsedQuantity, maxQuantity);
};

export const exceedsAvailableStock = (item, quantity) => {
  const maxQuantity = getMaxOrderableQuantity(item);

  if (maxQuantity === null) return false;

  return Number(quantity) > maxQuantity;
};

export const canBeSelected = (product = {}) => {
  if (!isEmpty(product.product_variant_combinations)) {
    const availables = filter(product.product_variant_combinations, (item) => validateAvailable(item));

    if (!isEmpty(availables)) return true;

    return false;
  }

  return validateAvailable(product);
};

export const orderByAvailable = (products) => {
  const availableProducts = filter(products, (item) => canBeSelected(item));
  const unavailableProducts = filter(products, (item) => !canBeSelected(item));

  return availableProducts.concat(unavailableProducts);
};
